import React, { useEffect } from 'react'
import Breadcrumb from '../../component/Breadcrumb'
import Procedures from './FormComponent/Procedures'
import Express from './FormComponent/Express'
import PaymentSideBlock from './FormComponent/PaymentSideBlock'
import { TbPointFilled } from 'react-icons/tb'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
 
import Footer from '../../component/Footer'

export default function GreffeDeFranceSélectionGreffe() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const DepartementData = [
    '01 Ain',
    '02 Aisne',
    '03 Allier',
    '04 Alpes-de-Haute-Provence',
    '05 Hautes-Alpes',
    '06 Alpes-Maritimes',
    '07 Ardèche',
    '08 Ardennes',
    '09 Ariège',
    '10 Aube',
    '11 Aude',
    '12 Aveyron',
    '13 Bouches-du-Rhône',
    '14 Calvados',
    '15 Cantal',
    '16 Charente',
    '17 Charente-Maritime',
    '18 Cher',
    '19 Corrèze',
    '20 Corse-du-sud',
    '20 Haute-corse',
    `21 Côte-d'Or`,
    `22 Côtes-d'armor`,
    '23 Creuse',
    '24 Dordogne',
    '25 Doubs',
    '26 Drôme',
    '27 Eure',
    '28 Eure-et-Loir',
    '29 Finistère',
    '30 Gard',
    '31 Haute-Garonne',
    '32 Gers',
    '33 Gironde',
    '34 Hérault',
    '35 Ille-et-Vilaine',
    '36 Indre',
    '37 Indre-et-Loire',
    '38 Isère',
    '39 Jura',
    '40 Landes',
    '41 Loir-et-Cher',
    '42 Loire',
    '43 Haute-Loire',
    '44 Loire-Atlantique',
    '45 Loiret',
    '46 Lot',
    '47 Lot-et-Garonne',
    '48 Lozère',
    '49 Maine-et-Loire',
    '50 Manche',
    '51 Marne',
    '52 Haute-Marne',
    '53 Mayenne',
    '54 Meurthe-et-Moselle',
    '55 Meuse',
    '56 Morbihan',
    '57 Moselle',
    '58 Nièvre',
    '59 Nord',
    '60 Oise',
    '61 Orne',
    '62 Pas-de-Calais',
    '63 Puy-de-Dôme',
    '64 Pyrénées-Atlantiques',
    '65 Hautes-Pyrénées',
    '66 Pyrénées-Orientales',
    '67 Bas-Rhin',
    '68 Haut-Rhin',
    '69 Rhône',
    '70 Haute-Saône',
    '71 Saône-et-Loire',
    '72 Sarthe',
    '73 Savoie',
    '74 Haute-Savoie',
    '75 Paris',
    '76 Seine-Maritime',
    '77 Seine-et-Marne',
    '78 Yvelines',
    '79 Deux-Sèvres',
    '80 Somme',
    '81 Tarn',
    '82 Tarn-et-Garonne',
    '83 Var',
    '84 Vaucluse',
    '85 Vendée',
    '86 Vienne',
    '87 Haute-Vienne',
    '88 Vosges',
    '89 Yonne',
    '90 Territoire de Belfort',
    '91 Essonne',
    '92 Hauts-de-Seine',
    '93 Seine-Saint-Denis',
    '94 Val-de-Marne',
    `95 Val-d'oise`,
    '971 Guadeloupe',
    '972 Martinique',
    '973 Guyane',
    '974 Réunion',
    '976 Mayotte',
    '977 Saint-Barthélémy',
    '978 Saint-Martin',

  ]
  return (
    <>

      <div className='md:max-w-[1200px] relative w-full h-full m-auto py-7 px-4 sm:px-4'>
        <Breadcrumb Accueil="Accueil" page="Journaux habilités" />
        <div className='relative my-12'>
          <div className='grid grid-cols-12 gap-5'>
            <div className='mb-8 col-span-12 lg:col-span-8'>
              <h1 className='text-lg sm:text-[22px] font-black text-primary'>L’annuaire des Greffes de France</h1>
              <p className='text-base font-normal text-primary mt-6'>En France, les greffes des tribunaux de commerce sont chargés de deux types de missions :</p>


              <ul className='mt-3'>
                <li className='flex gap-4 items-start text-primary'><TbPointFilled className='text-secondary text-base w-8 h-8' />Assurer la gestion administrative des audiences des juridictions auxquelles ils sont rattachés en vue de veiller au bon déroulement de ces audiences et de faire en sorte que les débats qui se déroulent soient consignés par écrit. </li>

                <li className='flex gap-4 mt-2 items-start text-primary'><TbPointFilled className='text-secondary text-base w-12 h-12' />D'autre part, ils sont chargés de dactylographier les jugements rendus par les juges consulaires et de les transmettre aux parties concernées. Ils doivent aussi signer les jugements rendus pour les authentifier.
                  Assurer la tenue à jour des dossiers des entreprises immatriculées aux registres du commerce et des sociétés. En conséquence, ils reçoivent les dossiers transmis par les centres de formalités des entreprises lors des créations de société.</li>
              </ul>

              <h6 className='text-lg font-semibold text-primary mt-6'>Annonces légales et Greffe</h6>
              <p className='text-base font-normal text-primary mt-6'>C'est au Greffe rattaché à votre localité que revient l'attestation de dépôt d'annonce légale nécessaire à la constitution de votre dossier. En outre, les greffes des tribunaux de commerce sont informés de l'ouverture de toute procédure de redressement ou de liquidation judiciaire et ils se chargent de la publication des jugements rendus à l'occasion de ces procédures. Il en est de même en cas de procédure de sauvegarde. </p>
              <p className='text-base font-normal text-primary mt-6'>Enfin, ils reçoivent les comptes annuels de toutes les sociétés tenues de publier leurs comptes et ils se chargent de mettre ces documents à la disposition du public pour que celui-ci puisse en prendre connaissance.</p>



              <FormControl className='w-full' style={{ margin: '40px 0 0', boxShadow: '0px 2px 8px rgba(126, 122, 122, 0.25)' }}>
                <InputLabel id="demo-simple-select-label">Sélectionnez un département</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Sélectionnez"
                >
                  {
                    DepartementData.map((items, index) => {
                      return (
                        <MenuItem value={index} key={index}>{items}</MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>
              <h6 className='text-base sm:text-lg text-primary font-semibold pt-16 block underline'>BOURG-EN-BRESSE - 3 PL PIERRE GOUJON 01011 BOURG EN BRESSE CEDEX</h6>
              <div className='bg-[#FBFBFB] rounded-[10px] p-5 mt-12'>
                <h6 className='text-lg font-semibold text-primary'>(01) AIN</h6>
                <p className='text-[15px] font-bold text-primary mt-6'>Greffe du tribunal de commerce de BOURG-EN-BRESSE – 01 (Ain)</p>
                <p className='text-[15px] font-normal text-primary mt-6'>
                  Le greffe du tribunal de commerce de BOURG-EN-BRESSE (01) est située 3 PL PIERRE GOUJON 01011 BOURG EN BRESSE CEDEX. Un greffe du tribunal de commerce doit être sollicité pour toutes modifications propres au statut d'une société. Une entreprise se doit de lui fournir une attestation 1annoncelegal pour toute modification de son statut.
                </p>
                <p className='text-[15px] font-normal text-primary mt-6'>
                  Passer par le greffe du tribunal de commerce de BOURG-EN-BRESSE fait partie des formalités légales à réaliser lors de la création d'une entreprise en 01 (Ain).
                </p>
                <div className='flex items-start gap-4 mt-12'>
                  <svg width="26" height="34" viewBox="0 0 26 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12.8164C1 6.29985 6.33894 1 12.9461 1C19.5532 1 24.8921 6.29985 24.8921 12.8164C24.8921 13.8048 24.7548 14.9651 24.4752 16.0598C24.1925 17.1661 23.7834 18.1315 23.2857 18.7844L24.081 19.3906L23.2857 18.7844L12.9461 32.3503L2.60643 18.7844C1.45498 17.2737 1 15.0871 1 12.8164ZM19.3941 12.8164C19.3941 9.27638 16.4973 6.42296 12.9461 6.42296C9.39488 6.42296 6.49809 9.27638 6.49809 12.8164C6.49809 16.3565 9.39488 19.2098 12.9461 19.2098C16.4973 19.2098 19.3941 16.3564 19.3941 12.8164Z" stroke="#1CBE93" stroke-width="2" />
                  </svg>
                  <div>
                    <h6 className='text-[15] font-semibold text-primary'>Adresse du Tribunal de commerce de BOURG-EN-BRESSE (01)</h6>
                    <p className='text-[15] text-primary font-normal mt-1'>Greffe du tribunal de commerce de BOURG-EN-BRESSE</p>
                    <p className='text-[15] text-primary font-normal'>3 PL PIERRE GOUJON</p>
                    <p className='text-[15] text-primary font-normal'>01011 BOURG EN BRESSE CEDEX</p>
                  </div>
                </div>
                <div className='flex items-start gap-4 mt-4'>
                  <svg width="23" height="31" viewBox="0 0 23 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.7085 8.78673L21.7088 8.78699C22.1529 9.23726 22.404 9.8497 22.4046 10.4901V27.125C22.4046 28.0225 22.0533 28.8818 21.4303 29.5141C20.8075 30.1463 19.9645 30.5 19.0871 30.5H3.81743C2.94003 30.5 2.09702 30.1463 1.47429 29.5141C0.851304 28.8818 0.5 28.0225 0.5 27.125V3.875C0.5 2.9775 0.851304 2.11824 1.47429 1.48586C2.09702 0.853732 2.94003 0.5 3.81743 0.5H12.5707C12.5707 0.5 12.5708 0.5 12.5708 0.5C13.1945 0.500164 13.7942 0.75155 14.2378 1.20141C14.2378 1.20147 14.2379 1.20152 14.2379 1.20157L21.7085 8.78673ZM11.9523 1.9375V1.4375H11.4523H3.81743C3.17616 1.4375 2.5627 1.69615 2.11157 2.15408C1.6607 2.61176 1.40871 3.23093 1.40871 3.875V27.125C1.40871 27.7691 1.6607 28.3882 2.11157 28.8459L2.46776 28.495L2.11157 28.8459C2.5627 29.3038 3.17616 29.5625 3.81743 29.5625H19.0871C19.7284 29.5625 20.3419 29.3038 20.793 28.8459C21.2439 28.3882 21.4959 27.7691 21.4959 27.125V11.625V11.125H20.9959H14.3154C13.6911 11.125 13.0908 10.8733 12.647 10.4229C12.203 9.97218 11.9523 9.35932 11.9523 8.71875V1.9375ZM20.6007 10.1875H21.7952L20.9569 9.3366L13.7172 1.98767L12.861 1.11856V2.33856V8.71875C12.861 9.10589 13.0124 9.47866 13.2843 9.75466C13.5565 10.0309 13.9272 10.1875 14.3154 10.1875H20.6007ZM4.31743 16.4688C4.31743 16.342 4.36709 16.222 4.45314 16.1346C4.53895 16.0475 4.65372 16 4.77178 16C4.88985 16 5.00462 16.0475 5.09043 16.1346C5.17648 16.222 5.22614 16.342 5.22614 16.4688C5.22614 16.5955 5.17648 16.7155 5.09043 16.8029C5.00462 16.89 4.88985 16.9375 4.77178 16.9375C4.65372 16.9375 4.53895 16.89 4.45314 16.8029C4.36709 16.7155 4.31743 16.5955 4.31743 16.4688ZM4.45314 20.0096C4.53895 19.9225 4.65372 19.875 4.77178 19.875C4.88985 19.875 5.00462 19.9225 5.09043 20.0096C5.17648 20.097 5.22614 20.217 5.22614 20.3438C5.22614 20.4705 5.17648 20.5905 5.09043 20.6779C5.00462 20.765 4.88985 20.8125 4.77178 20.8125C4.65372 20.8125 4.53895 20.765 4.45314 20.6779C4.36709 20.5905 4.31743 20.4705 4.31743 20.3438C4.31743 20.217 4.36709 20.097 4.45314 20.0096ZM4.31743 24.2188C4.31743 24.092 4.36709 23.972 4.45314 23.8846C4.53895 23.7975 4.65372 23.75 4.77178 23.75C4.88985 23.75 5.00462 23.7975 5.09043 23.8846C5.17648 23.972 5.22614 24.092 5.22614 24.2188C5.22614 24.3455 5.17648 24.4655 5.09043 24.5529C5.00462 24.64 4.88985 24.6875 4.77178 24.6875C4.65372 24.6875 4.53895 24.64 4.45314 24.5529C4.36709 24.4655 4.31743 24.3455 4.31743 24.2188ZM8.27057 16.1346C8.35637 16.0475 8.47114 16 8.58921 16H18.1328C18.2508 16 18.3656 16.0475 18.4514 16.1346C18.5375 16.222 18.5871 16.342 18.5871 16.4688C18.5871 16.5955 18.5375 16.7155 18.4514 16.8029C18.3656 16.89 18.2508 16.9375 18.1328 16.9375H8.58921C8.47114 16.9375 8.35637 16.89 8.27057 16.8029C8.18451 16.7155 8.13486 16.5955 8.13486 16.4688C8.13486 16.342 8.18451 16.222 8.27057 16.1346ZM8.13486 20.3438C8.13486 20.217 8.18451 20.097 8.27057 20.0096C8.35637 19.9225 8.47114 19.875 8.58921 19.875H18.1328C18.2508 19.875 18.3656 19.9225 18.4514 20.0096C18.5375 20.097 18.5871 20.217 18.5871 20.3438C18.5871 20.4705 18.5375 20.5905 18.4514 20.6779C18.3656 20.765 18.2508 20.8125 18.1328 20.8125H8.58921C8.47114 20.8125 8.35637 20.765 8.27057 20.6779C8.18451 20.5905 8.13486 20.4705 8.13486 20.3438ZM8.27057 23.8846C8.35637 23.7975 8.47114 23.75 8.58921 23.75H18.1328C18.2508 23.75 18.3656 23.7975 18.4514 23.8846C18.5375 23.972 18.5871 24.092 18.5871 24.2188C18.5871 24.3455 18.5375 24.4655 18.4514 24.5529C18.3656 24.64 18.2508 24.6875 18.1328 24.6875H8.58921C8.47114 24.6875 8.35637 24.64 8.27057 24.5529C8.18451 24.4655 8.13486 24.3455 8.13486 24.2188C8.13486 24.092 8.18451 23.972 8.27057 23.8846Z" fill="#27295B" stroke="#1CBE93" />
                  </svg>

                  <div>
                    <h6 className='text-[15] font-semibold text-primary'>Liste des journaux habilités pour la publication d'annonces legal dans le département de 01 (Ain)</h6>
                    <p className='text-[15] text-primary font-normal mt-1'>L'Ain Agricole</p>
                    <p className='text-[15] text-primary font-normal'>La Voix de l’Ain</p>
                    <p className='text-[15] text-primary font-normal'>La Tribune Républicaine</p>
                    <p className='text-[15] text-primary font-normal'>Le Progrès (Edition de l’Ain)</p>
                  </div>
                </div>
                <div className='mt-12 max-w-[836px] w-full min-h-[398px] h-full rounded-xl'>
                  <iframe title='france' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5666151.454104781!2d-3.2305647495523675!3d46.09744499642553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd54a02933785731%3A0x6bfd3f96c747d9f7!2sFrance!5e0!3m2!1sen!2sin!4v1685359635891!5m2!1sen!2sin" style={{ width: '100%', maxWidth: '836px', minHeight: '398px', height: '100%', borderRadius: '12px' }} loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>


            </div>
            <div className=' col-span-12 lg:col-span-4'>
              <Procedures />
              <Express />
              <PaymentSideBlock />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
